import { createContext, useContext } from "react";

import type { Section } from "~/providers/section-provider";

interface SectionContext {
  sections: Section[];
}

export const SectionContext = createContext<SectionContext | undefined>(
  undefined,
);

export const useSection = () => {
  const context = useContext(SectionContext);

  if (!context) {
    throw new Error("useSection must be used within a SectionProvider");
  }
  return context;
};
